import Vue from 'vue'
import VueResource from 'vue-resource'
import settings from '@/settings'

Vue.use(VueResource)

let apiUrl = settings.apiUrl
let version = settings.version

export default {
  PROJECTS: ({ commit, dispatch }, params) => {
    return new Promise((resolve, reject) => {
      Vue.http.post(`${apiUrl}${version}/projects/datatable`, params).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  PROJECT_NAMES: ({ commit, dispatch }, params) => {
    return new Promise((resolve, reject) => {
      Vue.http.post(`${apiUrl}${version}/projects/list`, params).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  CREATE_PROJECT: ({ commit, dispatch }, project) => {
    return new Promise((resolve, reject) => {
      Vue.http.post(`${apiUrl}${version}/projects`, project).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  EDIT_PROJECT: ({ commit, dispatch }, project) => {
    return new Promise((resolve, reject) => {
      Vue.http.put(`${apiUrl}${version}/projects/${project.id}`, project).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  ADD_ENGINE_TO_PROJECT: ({ commit, dispatch }, {projectId, engineId}) => {
    return new Promise((resolve, reject) => {
      Vue.http.post(`${apiUrl}${version}/projects/${projectId}/engine/${engineId}`).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  REMOVE_ENGINE_FROM_PROJECT: ({ commit, dispatch }, {projectId, engineId}) => {
    return new Promise((resolve, reject) => {
      Vue.http.delete(`${apiUrl}${version}/projects/${projectId}/engine/${engineId}`).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  GET_PROJECT: ({ commit, dispatch }, {projectId, engineId}) => {
    return new Promise((resolve, reject) => {
      Vue.http.post(`${apiUrl}${version}/projects/${projectId}`, { engine_id: parseInt(engineId) }).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  GET_PROJECTS_COUNT: ({ commit, dispatch }) => {
    return new Promise((resolve, reject) => {
      Vue.http.get(`${apiUrl}${version}/projects/info `).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  DELETE_PROJECT: ({ commit, dispatch }, projectId) => {
    return new Promise((resolve, reject) => {
      Vue.http.delete(`${apiUrl}${version}/projects/${projectId}`).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  DELETE_PROJECTS: ({ commit, dispatch }, projectIds) => {
    return new Promise((resolve, reject) => {
      Vue.http.post(`${apiUrl}${version}/projects/delete`, { project_ids: projectIds }).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  GET_TOP_COMPETITORS: ({ commit, dispatch }, { projectId, params }) => {
    return new Promise((resolve, reject) => {
      Vue.http.post(`${apiUrl}${version}/projects/${projectId}/competitors`, params).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  GET_TOP_INDEXED_PAGES: ({ commit, dispatch }, { projectId, params }) => {
    return new Promise((resolve, reject) => {
      Vue.http.post(`${apiUrl}${version}/projects/${projectId}/top-indexed-pages`, params).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  GET_SUGGESTED_BOX: ({ commit, dispatch }, { projectId, params }) => {
    return new Promise((resolve, reject) => {
      Vue.http.post(`${apiUrl}${version}/projects/${projectId}/top-suggested-keywords`, params).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  EXPORT_SUGGESTED_BOX: ({ commit, dispatch }, { projectId, params }) => {
    return new Promise((resolve, reject) => {
      Vue.http.post(`${apiUrl}${version}/projects/${projectId}/top-suggested-keywords/export`, params, {
        responseType: 'arraybuffer',
        headers: {'Accept': 'application/octet-stream'}
      }).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  EXPORT_COMPETITORS: ({ commit, dispatch }, { projectId, engineId }) => {
    return new Promise((resolve, reject) => {
      Vue.http.post(`${apiUrl}${version}/projects/${projectId}/competitors/export`, { engine_id: engineId }, {
        responseType: 'arraybuffer',
        headers: {'Accept': 'application/octet-stream'}
      }).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  EXPORT_INDEXED_PAGES: ({ commit, dispatch }, { projectId, params }) => {
    return new Promise((resolve, reject) => {
      Vue.http.post(`${apiUrl}${version}/projects/${projectId}/top-indexed-pages/export`, params, {
        responseType: 'arraybuffer',
        headers: {'Accept': 'application/octet-stream'}
      }).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  DOWNLOAD_AVERAGES_XLSX: ({ commit, dispatch }, { projectId, dateRangeType, engineId }) => {
    return new Promise((resolve, reject) => {
      Vue.http.post(`${apiUrl}${version}/projects/${projectId}/keywords/datatable-ranking-averages/download/xlsx`, { date_range_type: dateRangeType, engine_id: engineId }, {
        responseType: 'arraybuffer',
        headers: {'Accept': 'application/octet-stream'}
      }).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  CATEGORIES: ({ commit, dispatch }) => {
    return new Promise((resolve, reject) => {
      Vue.http.post(`${apiUrl}${version}/projects/categories`).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  SAVE_CATEGORIES: ({ commit, dispatch }, categories) => {
    return new Promise((resolve, reject) => {
      Vue.http.put(`${apiUrl}${version}/projects/categories`, {categories: categories}).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  SUBCATEGORIES: ({ commit, dispatch }) => {
    return new Promise((resolve, reject) => {
      Vue.http.post(`${apiUrl}${version}/projects/subcategories`).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  SAVE_SUBCATEGORIES: ({ commit, dispatch }, subcategories) => {
    return new Promise((resolve, reject) => {
      Vue.http.put(`${apiUrl}${version}/projects/subcategories`, {subcategories: subcategories}).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  // {"project_ids": [10052], "to_user_id": 4057}
  CHANGE_PROJECTS_OWNER: ({ commit, dispatch }, params) => {
    return new Promise((resolve, reject) => {
      Vue.http.put(`${apiUrl}${version}/projects/move`, params).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  SET_SUGGESTED_DOMAIN: ({ commit, dispatch }, {projectId, alternative}) => {
    return new Promise((resolve, reject) => {
      Vue.http.post(`${apiUrl}${version}/projects/${projectId}/suggested-domains-answer`, { apply_alternatives: alternative }).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/project/actions.js